<template>
  <table class="table table-striped">
    <tbody>
      <tr>
        <td>ID</td><td>{{ cat.map_id }}</td>
      </tr>
      <tr>
        <td>Name</td>
        <td v-if="cat.desc">{{ cat.desc.short_des }}</td>
      </tr>
      <tr>
        <td>Text</td><td v-if="cat.desc">{{ cat.desc.des }}</td>
      </tr>
      <tr>
        <td>Artikel</td><td v-if="cat.meta"><a :href="'/articles?cat=' + encodeURIComponent(cat.map_id)">{{ cat.meta.articles }}</a></td>
      </tr>
      <tr>
        <td>Zusatzfelder</td>
        <td>
          <ul v-if="cat.meta && cat.meta.submeta">
            <li v-for="(val,key) in cat.meta.fields" :key="key">{{ key }}</li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Tags</td>
        <td>
          <ul v-if="cat.meta && cat.meta.tags">
            <li v-for="(val,key) in cat.meta.tags" :key="key">
              <a href="/articles?tag=xxx">{{ key }} ({{ val }})</a>
            </li>
          </ul>
        </td>
      </tr>
      <tr>
        <td>Bild</td>
        <td>
          <img style="max-height:100px" :href="'rest/data/images/' + cat.map_pic_id  + '/1'">
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'CategoryInfo',
  props: ["cat"]
}
</script>
